import { useState } from "react";
import FeatureItem from "./FeatureItem";
import { useCheckout } from "../../checkout/CheckoutContext";
import { FEATURES_INITIAL_VISIBLE } from "../data/pricing.config";

const PricingCard = ({ plan, cycle }) => {
  const { openCheckout } = useCheckout();
  const [expanded, setExpanded] = useState(false);
  const price =
    plan.price[cycle] === 0 ? "Free" : `₹${plan.price[cycle]}/mo`;

  const features = plan.features ?? [];
  const hasMore = features.length > FEATURES_INITIAL_VISIBLE;
  const visibleFeatures = expanded
    ? features
    : features.slice(0, FEATURES_INITIAL_VISIBLE);

  return (
    <div
      className={`
        w-full border border-black rounded-lg py-5 px-[25px] flex flex-col justify-between transition ${
          plan.theme === "dark"
            ? "bg-black text-white scale-105"
            : "bg-white text-black"
        }`}
    >
      <div>
        <p className="text-sm font-semibold">{plan.name}</p>
        <h3 className="text-3xl font-bold mt-2">{price}</h3>

        <div className="mt-6 space-y-3 text-left">
          {visibleFeatures.map((f, i) => (
            <FeatureItem key={i} {...f} />
          ))}
          {hasMore && (
            <button
              type="button"
              onClick={() => setExpanded((e) => !e)}
              className={`text-sm font-medium mt-1 underline focus:outline-none ${
                plan.theme === "dark"
                  ? "text-white/80 hover:text-white"
                  : "text-black/70 hover:text-black"
              }`}
            >
              {expanded ? "Show less" : "Show more"}
            </button>
          )}
        </div>
      </div>

      <button
        disabled={plan.disabled}
        onClick={() => openCheckout(plan, cycle)}
        className={`mt-8 w-full py-3 rounded-lg font-semibold transition ${
          plan.disabled
            ? "bg-gray-200 text-gray-500 cursor-not-allowed"
            : plan.theme === "dark"
            ? "bg-white text-black hover:bg-gray-100"
            : "border border-black hover:bg-gray-50"
        }`}
      >
        {plan.cta}
      </button>

      <p className="text-xs text-center mt-3 opacity-70">
        Cancel anytime
      </p>
    </div>
  );
};

export default PricingCard;
